import { render, staticRenderFns } from "./BizAgreementinfoModal.vue?vue&type=template&id=425ee8e3&"
import script from "./BizAgreementinfoModal.vue?vue&type=script&lang=js&"
export * from "./BizAgreementinfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports